import {action, makeAutoObservable, observable, reaction} from 'mobx';
import {selectedCompanyStore} from "./SelectedCompany";
import {UnitOfMeasurements} from "../model/invoice/UnitOfMeasurements";
import {TaxDto} from "../model/invoice/TaxDto";
import {ArticleDto} from "../model/invoice/ArticleDto";
import {invoiceApi} from "../backend/InvoiceApi";
import {Nil} from "../utils/Types";
import {articleDescription, findNameByCode} from "../utils/InvoiceUtils";
import {userInfoStore} from "./UserInfo";

class InvoiceDataStore {
    @observable fetched: boolean = false;
    readonly uoms = observable<UnitOfMeasurements>([])
    readonly taxes = observable<TaxDto>([])
    readonly articles = observable<ArticleDto>([])

    constructor() {
        makeAutoObservable(this);
    }

    @action
    public async invalidate() {
        this.fetched = false;
    }

    @action
    public async refresh() {
        if (selectedCompanyStore.isSelected && userInfoStore.isAuthorized) {
            if (!this.fetched) {
                this.fetched = true;
                const uomsPromise = invoiceApi.fetchUOM();
                const taxesPromise = invoiceApi.fetchTaxes();
                const articlesPromise = invoiceApi.fetchArticles();
                this.uoms.replace(await uomsPromise);
                this.taxes.replace(await taxesPromise);
                this.articles.replace(await articlesPromise);
            }
        } else {
            this.uoms.clear()
            this.taxes.clear()
            this.articles.clear()
            this.fetched = false;
        }
    }

    public findArticleDesc = (code: string | Nil) => {
        return articleDescription(code, this.articles);
    }

    public findUomName = (code: string | Nil) => {
        return findNameByCode(code, this.uoms);
    }

    public findTaxName = (code: string | Nil) => {
        return findNameByCode(code, this.taxes);
    }
}

export const invoiceDataStore = new InvoiceDataStore();

reaction(
    () => selectedCompanyStore.companyId,
    () => invoiceDataStore.invalidate()
)

reaction(
    () => userInfoStore.email,
    () => invoiceDataStore.invalidate()
)
